<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="col-md-8 container-fluid">
<div class="common-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 mt-2 mb-4 heading">
    <span class="span-create-edit-hoshin color">ANNUAL PLAN</span>
    <span class="pt-1" *ngIf="(this.adminId==1 || this.adminId=='1')" style="font-size: 13px; padding-left: 10px;">
      <a [routerLink]="['/omnidashboard']" [queryParams]="{ view: 'annual-plan-status' }" class="pl-0 download-link" style=" color:black; font-weight: 100;font-family: Verdana, Geneva, Tahoma, sans-serif; text-decoration: underline;">
        Overall Status
      </a>
    </span>
    <span class="pt-1" *ngIf="(this.adminId==1 || this.adminId=='1')" style="font-size: 13px;"><a href="assets/userguides/ERG_UG_AnnualPlan_SuperAdmin.pdf" download class="pl-3 download-link">User Guide</a></span>
    <span class="pt-1" *ngIf="!(this.adminId==1 || this.adminId=='1')" style="font-size: 13px;"><a href="assets/userguides/ERG_UG_AnnualPlan_ERGAdmin.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>
  

  <div class="main-section">

    <div id='included_page' class="form-outer-div">    
      <div class="form-group-div">
        
          <ng-select placeholder="--Select SITE--" class="custom" [items]="siteList" bindLabel="siteName"
            bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)"></ng-select>
        
      </div>

      <div class="form-group-div">
        
          <ng-select placeholder="--Select ERG--" class="custom" [items]="bpgList" bindLabel="bpgName"
            [(ngModel)]="bpgId" bindValue="bpgId" (change)="bpgChange($event)"></ng-select>
       
      </div>

      <div class="form-group-div">
        
          <ng-select placeholder="--Select FY--" class="custom" [items]="fyDropdownList" bindLabel="fiscal"
            bindValue="fiscalYear" [(ngModel)]="fiscalYear" (change)="changeFy($event)">
          </ng-select>
        
      </div>

      <div class="form-group-div">
        
          <ng-select placeholder="--Select Status--" class="custom" [items]="statusList" bindLabel="status"
          bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)"></ng-select>
       
      </div>

      <div id="searchSecn" style="text-align: center;">
        <button type="button" class="btn btn-danger form-control" (click)="searchChapter()">Search</button>
      </div>
    </div>

  </div>
</div>

<p class="noDataFound" *ngIf="noDataFound"> No data found </p>
<div class="table-data" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped " id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" style="width: 25%;">Site</th>
          <th scope="col" style="width: 60%;">ERG</th>
          <th scope="col" style="width: 30%;">Status</th>
          <th scope="col" style="width: 10%;">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of chaptersData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
          <td>{{data.siteName}}</td>
          <td>{{data.bpgName}}</td>
          <td>{{data.budgetStatus === "REJECTED" ? "NOT APPROVED": data.budgetStatus}}</td>
          <td>
            <a style="color: #b62027; cursor: pointer;" (click)="viewMoreHoshinDetails(data)" title="Old Implementation"><b>V1</b></a>
            <a *ngIf="isAnnualPlanV2Year" class="view-v2-link" [routerLink]="['/annual-plan-v2/summary']"
              [queryParams]="{ context: encodedPlanContext(data.siteId, data.bpgId) }"
              [attr.aria-label]="'View V2 summary for ' + data.siteName + ' ' + data.bpgName" title="New Implementation"><b>V2</b></a>
          </td>
        </tr>

      </tbody>
    </table>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>
</div>